import styled from 'styled-components';
import IconButton from '@mui/material/IconButton';

export const StyledIconButton = styled(IconButton)`
  &.MuiButtonBase-root {
    padding: 4px;
  }
`;
